(function (ws) {
    'use strict';
    ws.views.modalRequiredProducts = ws.views.modal.extend({
        /**
         * Events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'change input[name=rp-qty]': 'validateQty'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            this.$invalidFormatError = this.$('.invalid-format');
            this.$reqProductTpl = $('#quote-required-products').html();
            this.$reqProductContainer = $('.required-products-container');
            ws.views.modal.prototype.initialize.call(this);
            this.productViews = [];
            this.elementsInModal = 0;
            this.model = null;
            this.isCart = true;
            if ($('body').hasClass('page-quotecartpage')) {
                this.cartPage = false;
            } else {
                this.cartPage = true;
            }

            this.eventAgg.on('qutRenderRequiredProducts', this.renderProducts, this);
            this.eventAgg.on('destroyView', this.destroyView, this);
        },

        /**
         * Validate quantity field
         * @param {Object} e
         */
        validateQty: function (e) {
            const $el = $(e.currentTarget);
            if ($.isNumeric($el.val())) {
                $el.removeClass('error');
                this.$invalidFormatError.hide();
            }
        },

        /**
         *
         * @param {*} data
         */
        renderProducts: function (data) {
            this.destroyPreviousProductInstancesViews();

            if (data && data.hasMandatoryAssociatedProducts) {
                data.mandatoryAssociatedProducts.forEach(function(mandatoryAssociatedProducts, index) {
                    mandatoryAssociatedProducts.cartPage = this.cartPage;
                    mandatoryAssociatedProducts.index = index;
                    const options = {
                        data: mandatoryAssociatedProducts,
                        template: this.$reqProductTpl,
                        model: this.model,
                        isCart: this.isCart
                    };
                    const view = new ws.views.modalRequiredProduct(options);
                    this.productViews.push(view);
                    this.elementsInModal++;
                    this.$reqProductContainer.append(view.render().el);
                }, this);
                this.onOpen();
            }

            if (data.mandatoryAssociatedProducts.length > 1) {
                $('.headerTagMultiple').show();
                $('.headerTagSingle').hide();
            } else {
                $('.headerTagSingle').show();
                $('.headerTagMultiple').hide();
            }
        },

        /**
         * Destroy and remove view from DOM.
         * @param {Object} view
         */
        destroyView (view) {
            this.elementsInModal--;
            this.checkViewsForCloseModal();
        },

        /**
         * Check if there is no more product view opened and close modal
         */
        checkViewsForCloseModal () {
            if (this.elementsInModal === 0) {
                this.eventAgg.trigger('refreshProductCart');
                this.onClose(true);
            }
        },

        /**
         * Destroy previous instances for required products
         */
        destroyPreviousProductInstancesViews () {
            _.invoke(this.productViews, 'destroy');
            this.productViews.forEach((view) => {
                view.$el.remove();
            });
            this.productViews = [];
        }
    });
})(westcon);
